import {NetworkService} from "./NetworkService";

export class IndicatorsServices {
  static async getIndicatorsList() {
    try {
      return await NetworkService.request({
        url: "indicators/list",
        method: "GET",
      });

    } catch (e) {
      return e;
    }
  }
}
